import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { addRestaurant, disableRestaurant, editRestaurant, enableRestaurant, getRestaurants } from '../../../actions/restaurantsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import RestaurantForm from '../../../components/forms/RestaurantForm'

export default function Restaurants() { 
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {client} = useAuth()

    const {restaurants, resultrestaurant, loading} = useSelector(state=>state.restaurants)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [imageAux, setImage] = useState(null)
    const [imagesAux, setImages] = useState([])
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [isSending, setIsSending] = useState(false)

    useEffect(() => {
        if(client){
            dispatch(getRestaurants('admin'))
        }
    },[dispatch, t, client])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            name: '',
            description: '',
            descriptionen: '',
            category: 'Tradicionalcordobesa',
            positionx: '',
            positiony: '',
            address: '',
            phone: '',
            web: '',
            facebook: '',
            x: '',
            instagram: '',
            opinions: [],
            images: [],
            plates: [],
            deliveryUrl: '',
        })
        setModalShow(true)
    }

    const selectRestaurant = (restaurant) => {
        setIsAddingOrEditing('editing')
        setFormState(restaurant)
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleSelectChange = (target) => {
        setFormState({
            ...formState,
            'category': target.target.value
        })
    }

    const handleImage = (e)=>{
        setImage(e.target.files[0])
    }

    const handleImages = (e) => {
        const files = Array.from(e.target.files)
        setImages(files)
    }

    const handleSubmit = async(e) => {
        e.preventDefault()
        setIsSending(true)
        if(isAddingOrEditing==='editing'){
            dispatch(editRestaurant(imageAux, imagesAux, formState, formState._id))
        }else{
            dispatch(addRestaurant(imageAux, imagesAux, formState))
            setFormState({})
            setImage(null)
            setImages([])
        }
        setIsSending(false)
    }
    
    const disableEnableRestaurants = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
                textQuestion = t('admin.restaurants.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'
            :
                textQuestion = t('admin.restaurants.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableRestaurant(formState._id))
                }else{
                    dispatch(enableRestaurant(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultrestaurant){
            let resultrestaurantTemp = resultrestaurant
            dispatch({ type: 'RESTAURANT_RESET_RESULT'})
            switch (resultrestaurantTemp) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.restaurants.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setFormState({})
                        setImage(null)
                        setImages([])
                        setIsSending(false)
                    })
                    break;
                case 'successedit':
                    setModalShow(false)
                    setFormState({})
                    setImage(null)
                    setImages([])
                    setIsSending(false)
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.restaurants.restaurantedit')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultrestaurant])

    const columnsRestaurants = [
        {
            name: t('admin.restaurants.name'),
            cell: restaurant =>
                <div className='cursor' onClick={() => selectRestaurant(restaurant)}>
                    {restaurant.name}
                </div>,
            selector: (restaurant) => restaurant.name,
            sortable: true,
        },{
            name: t('admin.restaurants.address'),
            cell: restaurant =>
                <div className='cursor' onClick={() => selectRestaurant(restaurant)}>
                    {restaurant.address}
                </div>,
            selector: (restaurant) => restaurant.address,
            sortable: true,
        },{            
            name: t('admin.restaurants.category'),
            cell: restaurant =>
                <div className='cursor' onClick={() => selectRestaurant(restaurant)}>
                    {t('typerestaurant.'+restaurant.category)}
                </div>,
            selector: (restaurant) => restaurant.category,
            sortable: true,
        },{
            name: t('admin.restaurants.active'),
            cell: restaurant =>
                <div className='cursor' onClick={() => selectRestaurant(restaurant)}>
                    {restaurant.active
                        ?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (restaurant) => restaurant.active,
            sortable: true,
        },{
            name: '',
            cell: restaurant =>
                <div className='cursor' onClick={() => selectRestaurant(restaurant)}>
                    {t('admin.restaurants.edit')}
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='mt-5 px-5'>
            <Row>
                <Col className='text-center'>
                    <h1>{t('admin.restaurants.restaurants')}</h1>
                </Col>
            </Row>
            <Row className="mt-5 mb-4">
                <Button variant='primary' type="submit" className="btn-primary my-2 button-withicon" onClick={() => openModal()}>
                    <label className='label-button'>{t('admin.restaurants.createrestaurant')}</label>
                </Button>
            </Row>
            {
                loading
                    ?
                        <Loader/>
                    :
                        <>
                            <Row className="mt-5 ">
                                <label className='sd-label-medium'>{t('admin.restaurants.listrestaurants')}</label>
                            </Row>
                            <Row className="fullwidth">
                                {restaurants?.length > 0
                                    ?
                                        <CustomDataTable columns={columnsRestaurants} data={restaurants} exportable={false} printable={false}/>
                                    :
                                        <h4 className='mt-4'>{t('admin.restaurants.thereisnotrestaurants')}</h4>
                                }
                            </Row>
                        </>
            }
            <Modal show={modalShow} size='xl' aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <i className='fa fa-times cursor' onClick={() => setModalShow(false)}></i>
                </Modal.Header>
                <Modal.Body>
                    <div className='text-center mb-5'>
                        <h2>{t('admin.restaurants.createrestaurant')}</h2>
                    </div>
                    <RestaurantForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleSelectChange={handleSelectChange}
                        handleImages={handleImages}
                        imagesAux={imagesAux}
                        handleImage={handleImage}
                        imageAux={imageAux}
                        submit={handleSubmit}
                        isAddingOrEditing={isAddingOrEditing}
                        isSending={isSending}
                        disableEnableRestaurants={disableEnableRestaurants}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}